<template>
  <v-app-bar app flat :prominent="isMobile">
    <v-app-bar-nav-icon
      v-if="!drawer"
      @click.stop="showDrawer"
    ></v-app-bar-nav-icon>
    <v-container>
      <v-row dense>
        <v-col cols="auto">
          <v-chip outlined @click="$emit('save')">
            <template v-if="saving">
              Saving...
              <v-progress-circular
                indeterminate
                color="secondary"
                size="20"
                class="ml-2"
              ></v-progress-circular>
            </template>
            <template v-else-if="saved">
              <v-badge dot inline color="success">All changes saved</v-badge>
            </template>
            <template v-else>
              <v-badge dot inline color="error">Save needed</v-badge>
            </template>
          </v-chip>
        </v-col>
        <v-spacer></v-spacer>
        <v-btn
          color="accent"
          class="mr-2 mb-2"
          @click="$emit('preview')"
          :disabled="disablePreview"
          :href="survey.previewLink"
          target="_blank"
        >
          {{ disablePreview ? "Save to Preview" : "Preview" }}
        </v-btn>
        <v-btn color="primary" class="mr-2 mb-2" @click="$emit('save')">
          Save
        </v-btn>
        <v-btn color="secondary" class="mb-2" @click="$emit('complete')">
          Finish
        </v-btn>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "BuilderAppBar",
  props: {
    saved: { type: Boolean, default: true },
    saving: { type: Boolean, default: false }
  },
  data: () => ({}),
  computed: {
    disablePreview() {
      return (
        !this.saved || this.saving || (this.survey.previewLink || "") == ""
      );
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    ...mapGetters({
      survey: "survey/edit_survey",
      drawer: "common/drawer"
    })
  },
  methods: {
    showDrawer() {
      this.$store.dispatch("common/setDrawer", true);
    }
  }
};
</script>
